"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _validationIcon = _interopRequireDefault(require("../validations/validation-icon.style"));

var _help = _interopRequireDefault(require("../../components/help/help.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const IconWrapperStyle = _styledComponents.default.div`
  display: inline-block;
  margin: 0;
  margin-left: 4px;
  width: 24px;
  height: 24px;
  position: relative;
  margin-top: -3px;
  margin-bottom: -4px;
  vertical-align: top;

  :focus {
    outline: ${({
  theme
}) => `2px solid ${theme.colors.focus}`};
  }

  ${_validationIcon.default}, ${_help.default} {
    position: static;
  }
`;
IconWrapperStyle.defaultProps = {
  theme: _base.default
};
var _default = IconWrapperStyle;
exports.default = _default;